const _Bar = require('./lib/Bar');
const _Presets = require('./presets/index');

// sub-module access
module.exports = {
    Bar: _Bar,
    Presets: _Presets
};